import {
  matchPath,
  Navigate,
  useLocation,
  useNavigate
} from "react-router-dom";

import { Stack, useTheme } from "@bps/fluent-ui";
import { VerticalTabs } from "@components/VerticalTabs";

import { SystemBpMobileTabs } from "./system-bp-mobile-tabs.constants";

export const SystemBpMobileSections: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const onSectionChange = (nextId: string) => {
    navigate(nextId);
  };

  const match = matchPath("/system/bp-mobile/:selectedTab", location.pathname);
  const selectedTab = match?.params?.selectedTab;

  if (!selectedTab) {
    return <Navigate to={SystemBpMobileTabs.Operations.Settings.id} replace />;
  }

  return (
    <Stack
      tokens={{
        childrenGap: theme.spacing.m
      }}
    >
      <VerticalTabs
        title="BpMobile"
        tabs={Object.values(SystemBpMobileTabs.Operations)}
        selectedTab={selectedTab}
        onSelectedTabChange={onSectionChange}
      />
    </Stack>
  );
};
